var map = {
	"./ristourne": [
		"2GUN",
		1,
		0
	],
	"./ristourne.js": [
		"2GUN",
		1,
		0
	],
	"./tickets": [
		"XXdC",
		0,
		3
	],
	"./tickets.js": [
		"XXdC",
		0,
		3
	],
	"./user": [
		"gnh2",
		2
	],
	"./user.json": [
		"gnh2",
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4/MX";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./test/mocks lazy ^\.\/.*$
// module id = 4/MX
// module chunks = 6